/**
 * Stories implemented by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { HeaderSection } from 'src/components/ZillowNavbar/page-frame-types/HeaderSection';
import { HeaderLink } from 'src/components/ZillowNavbar/page-frame-types/HeaderLink';
import { ZillowNavbarNotification } from 'src/components/ZillowNavbar/components/ZillowNavbarNotification';
import { HEADER_VERSIONS, MobileNavbarSectionTestID } from 'src/components/ZillowNavbar/constants';
import { setCypressID } from 'src/utils/setCypressID';
import { MobileDropdownMenuSectionContainer } from './components/MobileDropdownMenuSectionContainer';
import { MobileDropdownMenuSectionLinkAnchorRow } from './components/MobileDropdownMenuSectionLinkAnchorRow';
import { MobileDropdownMenuSectionLinkAnchor } from './components/MobileDropdownMenuSectionLinkAnchor';
import { MobileDropdownMenuSectionLinkAnchorContainer } from './components/MobileDropdownMenuSectionLinkAnchorContainer';
import { MobileDropdownMenuSectionDropdownTrigger } from './components/MobileDropdownMenuSectionDropdownTrigger';
import { MobileDropdownMenuMegaMenu } from './components/MobileDropdownMenuMegaMenu';

export type ZillowNavbarMobileDropdownMenuSectionProps = {
    section: HeaderSection;
    isExpanded: boolean;
    zhlHost: string;
    version: HEADER_VERSIONS;
    onSectionToggle: (section: string) => void;
};

export const MobileDropdownMenuSection: FunctionComponent<ZillowNavbarMobileDropdownMenuSectionProps> = ({
    section,
    zhlHost,
    isExpanded,
    version,
    onSectionToggle,
}) => {
    const testID = new MobileNavbarSectionTestID(`${section.link.text}`);
    return (
        <MobileDropdownMenuSectionContainer {...setCypressID(testID.id)}>
            <MobileDropdownMenuSectionLinkAnchorRow>
                <MobileDropdownMenuSectionLinkAnchorContainer>
                    <MobileDropdownMenuSectionLinkAnchor
                        isExpanded={isExpanded}
                        {...setCypressID(testID.anchor)}
                        href={(section.link as HeaderLink).href}>
                        {section.link.text}
                        {!!(section.link as HeaderLink).notifications && (
                            <ZillowNavbarNotification>
                                {(section.link as HeaderLink).notifications}
                            </ZillowNavbarNotification>
                        )}
                    </MobileDropdownMenuSectionLinkAnchor>
                </MobileDropdownMenuSectionLinkAnchorContainer>
                {!!section.subsections?.length && (
                    <MobileDropdownMenuSectionDropdownTrigger
                        onClick={() => onSectionToggle(section.link.text)}
                        {...setCypressID(testID.expandoTrigger)}
                        isExpanded={isExpanded}
                        ariaLabel={
                            isExpanded ? `Close ${section.link.text} sub-menu` : `Open ${section.link.text} sub-menu`
                        }
                    />
                )}
            </MobileDropdownMenuSectionLinkAnchorRow>
            {!!section.subsections?.length && isExpanded && (
                <MobileDropdownMenuMegaMenu
                    {...setCypressID(testID.megamenu)}
                    version={version}
                    isHomeLoansDashboardLinkRendered={section.link.text === 'Home Loans'}
                    zhlHost={zhlHost}
                    subsections={section.subsections!}
                />
            )}
        </MobileDropdownMenuSectionContainer>
    );
};
